import * as conf from "qpr-base/configuration";
import { MilestoneValues, Milestones } from "../ProjectForm/index.dto";
import { MeaElement, Milestone_JS_ATTR } from "./dataMapperTypes";

export const mapSubItemToMilestone = (
  projectId: string,
  data: MeaElement[],
  periods: string[]
): Milestones[] => {
  const lang: string[] = conf.getLanguages();

  return (data || []).map((milestone) => {
    const milestoneJsAttrUnparsed = milestone.values.find(
      (m) => m.series === "JS_ATTR"
    )?.value;
    const milestoneJsAttr = milestoneJsAttrUnparsed
      ? (JSON.parse(milestoneJsAttrUnparsed) as Milestone_JS_ATTR)
      : ({} as Milestone_JS_ATTR);
    const values = milestone.values || [];

    const mappedValues: MilestoneValues[] = periods.map((period) => {
      const valuesWithPeriod = values.filter((v: any) => v.period === period);
      const valueStartDate =
        valuesWithPeriod.find((v: any) => v.series === "ACTUAL_START_DATE")
          ?.value || "";
      const valueEndDate =
        valuesWithPeriod.find((v: any) => v.series === "ACTUAL_END_DATE")
          ?.value || "";
      return {
        period: period,
        milestoneProgress:
          valuesWithPeriod.find(
            (v: any) => v.series === "COMPLETION_PERCENTAGE"
          )?.value || "",
        milestonePlannedProgress:
          valuesWithPeriod.find((v: any) => v.series === "PLANNED_COMPLETION")
            ?.value || "",
        "Project Start Date": valueStartDate || "",
        // ? new Date(`${valueStartDate}T00:00:00-05:00`)
        // : undefined,
        "Project End Date": valueEndDate || "",
        // ? new Date(`${valueEndDate}T00:00:00-05:00`)
        // : undefined,
        milestoneWeight:
          valuesWithPeriod.find((v: any) => v.series === "WEIGHT")?.value || "",
        milestoneActualStartDate: "",
      };
    });

    const mapMilestoneValues = () => {
      const milestoneValueSeries = [
        "ACTUAL_START_DATE",
        "ACTUAL_END_DATE",
        "COMPLETION_PERCENTAGE",
        "PLANNED_COMPLETION",
        "EXPENDITURE",
      ];
      const valueObj: any = {};

      for (let i = 0; i < values.length; i += 1) {
        if (milestoneValueSeries.includes(values[i].series)) {
          valueObj[`${values[i].series}###${values[i].period}`] =
            values[i].value;
        }
      }
      return valueObj;
    };

    const end_date =
      milestone.values.find((m) => m.series === "END_DATE")?.value || "";
    const start_date =
      milestone.values.find((m) => m.series === "START_DATE")?.value || "";
    const weight = milestone.values.find((m) => m.series === "WEIGHT")?.value;

    return {
      milestoneId: milestoneJsAttr.ID || "",
      milestoneProjectId: projectId,
      meaId: milestone.meaId || "",
      status: milestone.operation || "",
      basicInformation: {
        [lang[0]]: {
          "Project Name":
            milestoneJsAttr["Localized-Text-Attributes"]?.[lang[0]]?.[
              "Project Name"
            ] || "undefined",
          "Milestone Description":
            milestoneJsAttr["Localized-Text-Attributes"]?.[lang[0]]?.[
              "Milestone Description"
            ] || "undefined",
        },
        [lang[1]]: {
          "Project Name":
            milestoneJsAttr["Localized-Text-Attributes"]?.[lang[1]]?.[
              "Project Name"
            ] || "undefined",
          "Milestone Description":
            milestoneJsAttr["Localized-Text-Attributes"]?.[lang[1]]?.[
              "Milestone Description"
            ] || "undefined",
        },
      },
      "Localized-Text-Attributes": {
        [lang[0]]: {
          "Project Name":
            milestoneJsAttr["Localized-Text-Attributes"]?.[lang[0]]?.[
              "Project Name"
            ] || "undefined",
          "Milestone Description":
            milestoneJsAttr["Localized-Text-Attributes"]?.[lang[0]]?.[
              "Milestone Description"
            ] || "undefined",
        },
        [lang[1]]: {
          "Project Name":
            milestoneJsAttr["Localized-Text-Attributes"]?.[lang[1]]?.[
              "Project Name"
            ] || "undefined",
          "Milestone Description":
            milestoneJsAttr["Localized-Text-Attributes"]?.[lang[1]]?.[
              "Milestone Description"
            ] || "undefined",
        },
      },
      "Milestone planned end date": end_date || "",
      // ? new Date(`${end_date}T00:00:00-05:00`)
      // : undefined,
      "Milestone planned start date": start_date || "",
      // ? new Date(`${start_date}T00:00:00-05:00`)
      // : undefined,
      "Milestone weight": weight || "",
      milestoneValues: mappedValues,
      values: mapMilestoneValues(),
    };
  });
};
